module.exports = __webpack_public_path__ + "static/pic09-16cde5d1a587ba354750901aa2a8655f.jpg";